<template>
  <div
    tabindex="0"
    class="auth-checkbox-root"
    :class="{
    active: active,
    errorState: errorCheckBox && !active
  }"  
    @keydown.space="evt => $emit('toggleChecked', evt)"
    @click="evt => $emit('toggleChecked', evt)"
  >
    <icon v-if="active" class="auth-checkbox-icon" name="check24" />
  </div>
</template>

<script>
import Icon from '@/assets/icons/Icon.vue'

export default {
  name: 'AuthCheckBox',

  components: { Icon },

  props: {
    active: {
      type: Boolean,
      required: true
    },
    errorCheckBox: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.auth-checkbox-root {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  border-radius: 5px;
  border: 2px solid var(--v-controls-background-inactive-default-base);
}

.active {
  border: 2px solid var(--v-controls-background-active-default-base);
  background-color: var(--v-controls-background-active-default-base);
}

.auth-checkbox-icon {
  width: 10px;
  height: 10px;
  color: var(--v-controls-foreground-active-base);
}

.errorState {
  border: 2px solid #F5222D;
}

.textError {
  color: var(--v-input-foreground-error-base)
}
</style>
